import Joi from 'joi-full';
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withHandlers } from 'recompose';
import {
  getBrandUserServices,
} from '../../../services/actions';
import FormServices from '../components/FormServices';
import { syncValidateData } from '../../../../common/validator';
import { TAXES_FORM_SERVICES } from '../constants';
import { getServiceCategoryFilters } from '../../../reports/selectors';
import { getActiveBrandId } from '../../../../auth/selectors';
import { getAll } from '../../../services/selector';

const schema = Joi.object()
  .keys({
    services: Joi.object()
      .pattern(/^[\w-]+$/, Joi.bool()
        .required(),
      ),
  });

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: TAXES_FORM_SERVICES,
  enableReinitialize: true,
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.router.push(props.baseUrl);
  },
  validate,
});

const FormServicesContainer = compose(
  withRouter,
  connect(state => ({
    services: getAll(state),
    filters: getServiceCategoryFilters(state),
    brandId: getActiveBrandId(state),
  }), { getBrandUserServices }),
  withProps(props => ({
    services: props.services.filter(service => props.filters.some(
      (filter) => {
        if (['uncategorised', 'uncategorized', null].includes(filter.id) && !service.categories.length) {
          return filter.checked;
        }

        if (service.categories.map(({ id }) => id).includes(filter.id)) {
          return filter.checked;
        }

        return false;
      }
    )),
  })),
  withHandlers({
    fetch: props => () => props.getBrandUserServices(props.brandId),
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetch();
    },
  }),
  form,
)(FormServices);

export default FormServicesContainer;
